import React, { lazy, Suspense } from 'react';

// the real window is in LoginModalContent.jsx and is downloaded the first time it is shown (it is only used after a click)
const LoginModalContent = lazy(() => import('./LoginModalContent'));

const LoginModal = (props) => (
    <Suspense fallback={null}>
        <LoginModalContent {...props} />
    </Suspense>
);

export default LoginModal;
